import * as React from 'react';
import { useEffect, useState } from 'react';
import { Card, CardTitle, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import { Entity, getNameForAfr, getSelectedEntity } from '../../redux/EntitySlice';
import { getTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { UserRoleEnum } from '../../redux/UserSlice';
import utilityHelper from '../../utils/utilityHelper';
import AdminComment from '../feature/AdminComment';
import AuditorRequestManager from '../feature/AuditorRequestManager';
import BypassRequest from '../feature/BypassRequest';
import DocumentList from '../feature/DocumentList';
import EventList from '../feature/EventList';
import SummaryAdministrationTab from '../feature/SummaryAdministrationTab';
import Page from '../Page';


const AfrSummaryCore = (props: { userRole: string, dataSection : string }) => {
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab: any) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: any) => {
        return (tab === activeTab) ? "active" : "";
    }

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const taxType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    var importLabel = "";
    var downloadTemplateLabel = "";
    switch (taxType) {
        case "COURT_REPORTING_939":
            importLabel = "Click here to upload the Court Reporting 939.185 Spreadsheet";
            downloadTemplateLabel = "Download a Court Reporting 939.185 Data Template";
            break;

        case "COURT_REPORTING_29":
            importLabel = "Click here to upload the Court Reporting 29.0085 Spreadsheet";
            downloadTemplateLabel = "Download a Court Reporting 29.0085 Data Template";
            break;
    }

    useEffect(function () {
        if (props.userRole === "ADMIN") {
            setActiveTab("4");
        }
    }, [])

    return (
        <React.Fragment>
            { currentAfr != null && entity != null ?
                <Page>
                    <h2>{utilityHelper.getTaxonomyDescriptor(taxType)} {props.dataSection} for {getNameForAfr(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {utilityHelper.getAfrYearDescriptor(currentAfr)}</h2>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={activeClass('1')}
                                    onClick={() => { toggle('1'); }}
                                >
                                    History
                            </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeClass('2')}
                                    onClick={() => { toggle('2'); }}
                                >
                                    Documents
                            </NavLink>
                            </NavItem>
                            {currentAfr.status.toLowerCase() !== "reported_by_primary" && taxType === TaxonomyTypeEnum.AFR ?
                                <NavItem>
                                    <NavLink
                                        className={activeClass('3')}
                                        onClick={() => { toggle('3'); }}
                                    >
                                        Bypass Requests
                                </NavLink>
                                </NavItem>
                                : <div></div>
                            }
                            {props.userRole === UserRoleEnum.Admin ?
                                <NavItem>
                                    <NavLink
                                        className={activeClass('4')}
                                        onClick={() => { toggle('4'); }}
                                    >
                                        Administration
                                </NavLink>
                                </NavItem>
                                : <div></div>}
                            {taxType === TaxonomyTypeEnum.AFR ?
                                <NavItem>
                                    <NavLink
                                        className={activeClass('5')}
                                        onClick={() => { toggle('5'); }}
                                    >
                                        Auditor Requests
                                </NavLink>
                                </NavItem>
                                : <div></div>                                     
                            }
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <CardTitle>History of events regarding the status of the AFR.</CardTitle>
                                            <EventList types="" eventsToShow={null} title="Events for current version" />
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {props.userRole === UserRoleEnum.Admin ?
                                            <AdminComment /> : <div></div>}
                                    </Col>
                                </Row>

                            </TabPane>
                            <TabPane tabId="2">
                                <Row>
                                    <Col sm="12">
                                        <Card body>
                                            <CardTitle>This will be a list of documents such as audits, waivers etc.</CardTitle>
                                            <DocumentList userRole={props.userRole} taxonomyType={taxType} importLabel={importLabel} downloadTemplateLabel={downloadTemplateLabel}/>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="3">
                                <Row>
                                    <Col>
                                        {currentAfr.status.toLowerCase() !== "reported_by_primary" && taxType === TaxonomyTypeEnum.AFR ?
                                            <Card body>
                                                <BypassRequest userRole={props.userRole} />
                                            </Card>
                                            : <div></div>
                                        }
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="4">
                                <Row>
                                    <Col sm="12">

                                        {props.userRole === UserRoleEnum.Admin ?
                                            <SummaryAdministrationTab /> : <div></div>}

                                    </Col>
                                </Row>
                            </TabPane>
                            {taxType === TaxonomyTypeEnum.AFR
                                ?
                                <TabPane tabId="5">
                                    <Row>
                                        <Col>
                                            <Card body>
                                                <AuditorRequestManager />
                                            </Card>
                                        </Col>
                                    </Row>
                                </TabPane>
                                : <div></div>
                            }
                        </TabContent>
                    </div>
                </Page>
                : <div></div>}
        </React.Fragment>
    );
}

export default AfrSummaryCore;